import React, {ReactNode, useEffect, useRef, useState} from 'react';
import {Backdrop, Paper, Popper} from '@mui/material';
import {useSelector} from 'react-redux';
import {RootState} from '../../redux/store';
interface ECAFlyoutProps {
  showFlyout: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  content: ReactNode;
  className?: string;
  containerStyle?: React.CSSProperties;
  positions?: {
    top: number;
    left: number;
  };
  type?: string;
}

const ECAFlyout: React.FC<ECAFlyoutProps> = ({
  showFlyout,
  anchorEl,
  onClose,
  content,
  className,
  containerStyle = {},
  positions = {
    top: 0,
    left: 0,
  },
  type = 'load',
}) => {
  const popperRef = useRef<HTMLDivElement | null>(null);
  const isModal: boolean = useSelector(
    (state: RootState) => state.ecaAdhocSearch.isDeduplicationModal
  );

  const [relativeTop, setRelativeTop] = useState(0);
  const headerHeight = 144;
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        popperRef.current &&
        !popperRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    }
    if (showFlyout && !isModal) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFlyout, onClose, anchorEl, isModal]);

  useEffect(() => {
    const anchorTop = anchorEl?.getBoundingClientRect().top ?? 0;
    const relativeTop = positions.top - anchorTop;
    setRelativeTop(relativeTop > 0 ? relativeTop : -relativeTop);
  }, [positions]);

  return (
    <>
      <Backdrop open={showFlyout} className="flyout-backdrop-container" />
      <Popper
        sx={{zIndex: 3}}
        open={showFlyout}
        anchorEl={anchorEl}
        placement={type == 'tag' ? 'right-start' : 'right'}
        modifiers={[
          {
            name: 'offset',
            options: {
              offset: [positions.top ? relativeTop - headerHeight : 0, 0],
            },
          },
        ]}
      >
        <div ref={popperRef} className={className ?? 'custom-popper'}>
          <Paper style={containerStyle}>{content}</Paper>
        </div>
      </Popper>
    </>
  );
};

export default ECAFlyout;
